export interface SubI {
  id: number;
  userId: number;
  planId: number;
  status: string;
  startDate: number;
  endDate: number;
  created: number;
  updated: number;
  checkoutUrl?: string;
}

export interface SubsStateI {
  subs: SubI[];
  sub: SubI;
}

export const state: SubsStateI = {
  subs: [],
  sub: {
    id: 0,
    userId: 0,
    planId: 0,
    status: '',
    startDate: 0,
    endDate: 0,
    created: 0,
    updated: 0,
    checkoutUrl: '',
  },
};
